const timestamp = value => {
  const parsed = Date.parse(value || '');
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const normalizeTeamRealtimeRecord = record => {
  const message = record?.message || {};
  return {
    id: record?.id,
    role: record?.message_type,
    message_type: record?.message_type,
    content: String(message.content || ''),
    function_name: message.function_name || null,
    reply_suggestion: Boolean(message.reply_suggestion),
    created_at: record?.created_at || null,
  };
};

export const mergeTeamMessages = (current, incoming) => {
  const byId = new Map();
  [...current, ...incoming].forEach(item => {
    if (item?.id) byId.set(item.id, item);
  });
  return [...byId.values()].sort((left, right) => {
    const time = timestamp(left.created_at) - timestamp(right.created_at);
    return time || String(left.id).localeCompare(String(right.id));
  });
};

export const resolveRealtimeThreadRef = ({
  records,
  selectedThreadRef,
  conversationId,
  sending,
  sendStartedAt,
}) => {
  if (selectedThreadRef) return selectedThreadRef;
  if (!sending || !sendStartedAt) return null;
  const floor = sendStartedAt - 2000;
  const expectedConversationRef =
    conversationId === null || conversationId === undefined
      ? ''
      : String(conversationId);
  const candidates = records
    .filter(
      record =>
        record?.thread_ref &&
        String(record.conversation_ref || '') === expectedConversationRef &&
        timestamp(record.created_at) >= floor
    )
    .sort(
      (left, right) => timestamp(left.created_at) - timestamp(right.created_at)
    );
  return candidates[candidates.length - 1]?.thread_ref || null;
};

export const realtimeMessagesForThread = (records, threadRef) =>
  records
    .filter(record => record?.thread_ref === threadRef)
    .map(normalizeTeamRealtimeRecord);
